<template>
  <div>
    <blockquote v-if="task.description">
      {{ task.description }}
    </blockquote>
    <h5>{{ $t('Student answer') }}</h5>
    <blockquote v-if="task.taskType === 'quiz' || task.taskType === 'form'">
      {{ JSON.stringify(answer.payload) }}
    </blockquote>
    <blockquote v-else-if="task.taskType === 'answer'">
      {{ answer.answer }}
    </blockquote>
    <blockquote v-else-if="task.taskType === 'upload'">
       <a :href="answer.upload" download>Download file</a>
    </blockquote>
    <validation-observer
      v-slot="{handleSubmit}"
      ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-md-12">
              <base-input
                :label="$t('Reviewer notes')"
                :name="$t('Reviewer notes')"
              >
              <textarea
                v-model="model.reviewerNote"
                maxlength="1000"
                class="form-control"
                rows="3">
              </textarea>
              </base-input>
            </div>
          </div>
        <base-button
          type="success"
          :loading="loading"
          native-type="submit">
          {{ $t('Apply answer') }}
        </base-button>
        <base-button
          type="warning"
          :loading="loading"
          @click="declineAnswer">
          {{ $t('Decline answer') }}
        </base-button>
      </form>
    </validation-observer>

  </div>
</template>


<script>
  import {createNamespacedHelpers} from 'vuex';
  import {ReviewForm} from "../../../mixins/Task/ReviewForm";
  import {FormNotification, FormSubmitHandlers} from "../../../mixins/FormApiHandlers";
  const {mapActions, mapState} = createNamespacedHelpers('course/audience');

  export default {
    name: "FormCreateTaskReview",
    components: {},
    props: {
      task: Object,
      answer: Object
    },
    data() {
      return {
        status: 0,
        successMessage: this.$i18n.t('You have reviewed student answer!'),
        errorMessage: this.$i18n.t('Error on sending review!'),
      }
    },
    mixins: [ReviewForm, FormNotification, FormSubmitHandlers],
    computed: {
      ...mapState({
        vuexStatus: state => state.createStatus
      })
    },
    mounted() {
      this.submitRedirectTo = this.redirect
    },
    watch: {
      'vuexStatus': function(val) {
        this.status = val.status
      }
    },
    methods: {
      async addReview(payload) {
        await this.$store.dispatch('course/audience/addTaskReview', payload)
      },
      revertStatus() {
        this.status = 0;
      },
      async formSubmit() {
        await this.addReview({
          urlParams: {...this.$route.params, answerId: this.answer.id},
          form: {...this.model}
        });
        this.$emit('onSend')
      },
      async declineAnswer() {
        this.model.status = 'need_answer'
        const valid = await this.$refs.formValidator.validate();
        if (valid) await this.formSubmit()
      },

    }
  }
</script>

<style scoped lang="scss">

</style>
